import config from '../config';
import postal from 'postal';
import _ from 'lodash';
import constants from '../constants';
import { useContext } from 'react';
import ApplicationContext from '../ApplicationContext';
import { GenEmailArgs } from '../fms.report/args';
import { DocumentType } from '../framework.core/DocumentType';
import { getFmsGlobal } from '../globals';
import { nowDate } from '../dateUtils';
import moment from 'moment';

export default function useReportViewer() {
  /**
   * Publish request-to-open-report-opTab
   * @param reportArgs 
   * @param opType {optional constants.opType, default = accounting}
   */

  const appContext = useContext(ApplicationContext);

  function checkPopupAvailable() {
    let result = true;

    //check report popup
    let n1 = window.open(config.serverUrl,
      '_blank',
      `toolbar=no, location=no, directories=no, status=no, menubar=no, width=10, height=10, left=${window.innerWidth - 10},top=${window.innerWidth - 10}`);
    // show bottom right corner of the screen.
    if (n1 == null) {
      result = false;
    } else {
      n1.close();
    }

    let n2 = window.open(config.serverUrl,
      '_blank',
      `toolbar=no, location=no, directories=no, status=no, menubar=no, width=15, height=15, left=${window.innerWidth - 10},top=${window.innerWidth - 10}`);
    // show bottom right corner of the screen.
    if (n2 == null) {
      // alert
      //console.log('viewReport - test')
      result = false;
    } else {
      n2.close();
    }

    return result;
  }

  function openPostWindow(url: string, params: Record<string, string>, target: string, features: string = '') {
    const popup = window.open('', target, features);
    if (!popup) return null;
  
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.target = target;

    const allParams = {
      ...params,
      useNameInFromAddr: String(appContext.systemSettings?.useNameInFromAddr ?? false),
    };
  
    Object.entries(allParams).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });
  
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
  
  function viewReport(reportArgs: any, opType?: string, popup: boolean = false, hlink: boolean = false, multi: boolean = false) {
    (document.activeElement as HTMLElement).blur();
  
    if (!checkPopupAvailable()) {
      alert('Please allow popups for this website.');
      return;
    }
  
    if (!popup) {
      const channel = postal.channel('report');
      if (!opType) opType = constants.opTypes.accounting;
  
      channel.publish('report.view', {
        reportId: _.isObject(reportArgs) ? JSON.stringify(reportArgs) : reportArgs,
        opType,
      });
      return;
    }

    const mainTarget = `ifmsmain-${appContext.user?.suntekId?.toLowerCase()}-${appContext.user?.id?.toLowerCase()}`;
    window.name = mainTarget; // index.html > window.open('', 'ifmsmain-' + suntekId + '-' + userId)?.focus();

    openPostWindow(
      `${config.serverUrl}report`,
      {
        args: `${hlink ? 'hlink-' : ''}${encodeURIComponent(hlink ? reportArgs : JSON.stringify(reportArgs))}`,
        hlink: hlink ? 'true' : 'false',
        argsType: multi ? 'multi' : '',
        jwt: appContext.api.getAuthKey(),
      },
      `reportpopup-${Date.now()}`,
    );
  }

  function viewEmptyReport(faxMode: boolean = true, toCompanyList: string = '', cfsType: string = '', content: string = '', tbName: string = '', tbId: number = 0) {
    let reportArgs = new GenEmailArgs({
      toCompanyid: toCompanyList,
      generalMode: true,
    });

    if (faxMode) {
      reportArgs.formCaption = 'General Fax';
      reportArgs.docType = DocumentType.GenFax;
      //preview.SetViewMode((int)PrintPreviewViewMode.Fax);
      //preview.CancelButton = preview.btnFaxCancel;

    } else {
      reportArgs.formCaption = 'General Email';
      reportArgs.docType = DocumentType.GenEmail;
      if (['Manifest', 'Release'].indexOf(cfsType) >= 0) {
        reportArgs.tbName = tbName;
        reportArgs.tbId = tbId.toString();
      }

      // 250623.inhyung. toCompanyList 존재시 tbId를 args에 할당해줌.
      if (toCompanyList) {
        //preview.SetViewMode((int)PrintPreviewViewMode.Email);
        reportArgs.tbName = tbName;
        reportArgs.tbId = tbId.toString();
      } 
      
      // preview.CancelButton = preview.btnEmailCancel;
    }

    if (cfsType || content) {
      //preview.Memo = content;
      reportArgs.memo = content;
      if (content && getFmsGlobal().AcmeID4 === "STAR") {
        reportArgs.subject = "STAR ASIA COMMUNICATION " + moment(nowDate()).format('MM-DD-YYYY');
      }
      else {
        reportArgs.subject = "Various";
      }

      reportArgs.cfsType = cfsType;
    }

    const url = `${config.serverUrl}report`;
    const params = {
      args: JSON.stringify(reportArgs),
      jwt: appContext.api.getAuthKey(),
    };

    let left = Math.ceil((window.screen.width - 980) / 2);
    left += window.screenLeft;
    let top = Math.ceil((window.screen.height - 650) / 2);

    openPostWindow(url, params, 'reportPopup', `popup, width=1290, height=750, left=${left}, top=${top}, scrollbars=yes`);
  }

  return { viewReport, viewEmptyReport };
}
